import { ElementRef, Injectable } from '@angular/core';
import { GridOptions, Grid } from 'ag-grid';
import { Observable } from 'rxjs/Rx';

export class AgGridHelper {
  private gridOptions: GridOptions;
  public el: ElementRef;
  private scrollArrowHoverTimer: any;
  private scrollMax: number;
  private isScrollToRightSide = false;
  public isShowGridNoDataOverlay = false;

  readonly CLS_AG_BODY_VIEWPORT = 'div.ag-body-viewport';
  readonly CLS_FILTER_OVERLAY = '.ag-bl-overlay.filter-overlay.no-data';
  readonly CLS_NODATA_OVERLAY = 'p.nodata';
  readonly CLS_FILTER_OVERLAY_BAD_OWNER = '.ag-bl-overlay.filter-overlay.bad-owner';
  readonly CLS_FILTER_OVERLAY_LOADING = '.loader-div-wrapper';
  readonly TEMPLATE_GRID_LOADING = '<div class="loader-div-wrapper"><div class="loaderdiv"><div class="loaderdiv-loader"></div></div></div>';
  readonly TEMPLATE_GRID_NODATA = '&nbsp;';
  readonly TEMPLATE_GRID_NODATA_FILTER =
    '<div class="ag-bl-overlay filter-overlay no-data" ref="overlay" style=""><div class="ag-overlay-panel" role="presentation"><div class="ag-overlay-wrapper ag-overlay-no-rows-wrapper"><p class="nodata">検索条件に一致する項目はありません。</p></div></div></div>';
  readonly TEMPLATE_GRID_BAD_OWNER =
    '<div class="ag-bl-overlay filter-overlay bad-owner" ref="overlay" style=""><div class="ag-overlay-panel" role="presentation"><div class="ag-overlay-wrapper ag-overlay-no-rows-wrapper"><p class="nodata" style="background-color: #f7f7f7;">データが存在しません。もしくは、荷主が選択されていません。</p></div></div></div>';

  public scrollArrowCustomVarietyValue = 0;
  public onViewportScrollListener = null;
  private isPrepareSelectedAnimation = false;
  private selectedNodeIndexsForAnimation = [];

  readonly FIELD_NAMES_SHOW_ON_SCROLL = [
    {
      rule: 'widthMoreThan',
      value: '285',
      name: 'col1Scroll',
      action: 'display'
    }
  ];

  readonly GRID_SELECTION_CHECKBOX_STYLES = {
    checkbox: {
      normal: '../../../../assets/images/checkbox_body.png',
      checked: '../../../../assets/images/checkbox_checked.png'
    },
    radio: {
      normal: '../../../../assets/images/radio_body.png',
      checked: '../../../../assets/images/radio_checked.png'
    }
  };

  public gridSelectionCheckboxStyle = 'checkbox';

  public isShowPaginiation = false;
  public isOwnerNotFound = false;

  constructor() { }

  setGridOptions(gridOptions: GridOptions) {
    this.gridOptions = gridOptions;
  }

  onGridReady() {
    var scrollArea = this.el.nativeElement.querySelector(this.CLS_AG_BODY_VIEWPORT);
    scrollArea.addEventListener('scroll', event => {
      this.onGridScroll(event);
    });
  }
  onRowDataChanged() {
    this.renderScrollArrow();
    this.renderGridCheckboxImage();
    /*
      if (this.gridOptions.api.getDisplayedRowCount() > 0) {
        this.isShowGridNoDataOverlay = false;
      } else {
        this.isShowGridNoDataOverlay = !this.gridOptions.api.isAnyFilterPresent();
      }
      */
    this.renderOverlays();
  }
  onPaginationChanged() {
    this.renderGridCheckboxImage();
  }

  renderScrollArrow() {
    var scrollArrow = this.el.nativeElement.querySelector('div.scrollArrow');
    if (scrollArrow == null) return;

    //初期表示しているすべて（TAB4）のみロード時に横スクロールの場所設定を行う
    var agGrid = this.el.nativeElement.querySelector('.ag-spread');
    var fullWidthContainer = agGrid.querySelector('div.ag-body-container');

    var agBodyViewPort = agGrid.querySelector('div.ag-body-viewport');
    var tbarea = this.getElementHeight(agBodyViewPort);
    if (this.getElementHeight(fullWidthContainer) > tbarea) {
      //スクロールバーがある場合の処理
      scrollArrow.style.right = '16px';
    } else {
      //スクロールバーがない場合の処理
      scrollArrow.style.right = '0px';
    }

    var bodyContainerWidth = this.getElementWidth(fullWidthContainer);
    tbarea = agBodyViewPort.scrollLeft + this.getElementWidth(agBodyViewPort);

    if (bodyContainerWidth - tbarea > 0) {
      //scrollArrow.style.display = 'flex';
      //var height = this.getElementHeight(agBodyViewPort) + this.scrollArrowCustomVarietyValue;
      //var height = this.getElementHeight(this.el.nativeElement.querySelector('.ag-spread')) + this.scrollArrowCustomVarietyValue;
      //var height = this.getElementHeight(this.el.nativeElement.querySelector('.ag-spread')) - this.getElementHeight(this.el.nativeElement.querySelector('.ag-paging-panel')) - this.getElementHeight(this.el.nativeElement.querySelector('.ag-pinned-left-header'));
      //var dspheight = this.getElementHeight(fullWidthContainer);
      //var gh = 0;
      //if (height < dspheight) gh = height;
      //else gh = dspheight;
      //var gh = height;
      //scrollArrow.style.height = gh + 'px';
    } else scrollArrow.style.display = 'none';
  }

  renderScrollArrowDelay(delay?: number) {
    setTimeout(
      () => {
        this.renderScrollArrow();
      },
      delay == null ? 50 : delay
    );
  }

  getElementValue(element, propName) {
    return window.getComputedStyle(element).getPropertyValue(propName);
  }
  getElementHeight(element) {
    return parseFloat(this.getElementValue(element, 'height'));
  }
  getElementWidth(element) {
    return parseFloat(this.getElementValue(element, 'width'));
  }

  /**
   * Horizontal scroll ag-grid, triggle by ScrollArrow in focus
   */
  scrollGridHorizontal() {
    var bodyContainerWidth = this.getElementWidth(this.el.nativeElement.querySelector('.ag-body-container'));
    var viewPortWidth = this.getElementWidth(this.el.nativeElement.querySelector(this.CLS_AG_BODY_VIEWPORT));
    this.scrollMax = bodyContainerWidth - viewPortWidth;

    var viewport = this.el.nativeElement.querySelector(this.CLS_AG_BODY_VIEWPORT); //ag-center-cols-viewport
    viewport.scrollLeft += 20;
    if (this.scrollMax <= viewport.scrollLeft && !this.isScrollToRightSide) {
      var scrollArrow = this.el.nativeElement.querySelector('div.scrollArrow');
      scrollArrow.style.display = 'none';
      this.isScrollToRightSide = true;
      this.arrowBlur();
    }
  }

  /**
   * ScrollArrow in focus
   */
  arrowFocus() {
    this.scrollArrowHoverTimer = setInterval(() => {
      this.scrollGridHorizontal();
    }, 100);
  }

  /**
   * ScrollArrow out focus
   */
  arrowBlur() {
    clearInterval(this.scrollArrowHoverTimer);
  }

  /**
   * ag-grid scrollbar scrolling callback
   * @param event
   */
  onGridScroll(event) {
    var bodyContainerWidth = this.getElementWidth(this.el.nativeElement.querySelector('.ag-body-container'));
    var viewPortWidth = this.getElementWidth(this.el.nativeElement.querySelector(this.CLS_AG_BODY_VIEWPORT));
    this.scrollMax = bodyContainerWidth - viewPortWidth;

    var scrollArrow = this.el.nativeElement.querySelector('div.scrollArrow');
    if (scrollArrow != null) { 
      if (this.scrollMax <= event.target.scrollLeft) {
        scrollArrow.style.display = 'none';
        this.isScrollToRightSide = true;
      }
      if (this.scrollMax > event.target.scrollLeft && this.isScrollToRightSide) {
        scrollArrow.style.display = 'flex';
        this.isScrollToRightSide = false;
      }
    }

    this.FIELD_NAMES_SHOW_ON_SCROLL.forEach(element => {
      this.triggerFieldOnScroll(event, element);
    });
    this.renderGridCheckboxImage();

    if (this.onViewportScrollListener) this.onViewportScrollListener();
  }

  triggerFieldOnScroll(event, element) {
    if (element.rule === 'widthMoreThan') {
      var columns = this.gridOptions.columnApi.getAllColumns();
      if (columns.length == 0) return;
      columns.forEach(column => {
        if (column['colId'].indexOf(element.name) != -1) this.triggerFieldOnScrollRuleWidth(event, element, column);
      });
    }
  }
  triggerFieldOnScrollRuleWidth(event, element, column) {
    var edgePosition = parseInt(element.value);
    var _symbolPosition = column['colId'].indexOf(':');
    if (_symbolPosition != -1) edgePosition = parseInt(column['colId'].substring(_symbolPosition + 1));

    var isShow = false;
    if (event.target.scrollLeft > edgePosition) {
      isShow = true;
    }
    if (element.action === 'display') this.showHideColumnOnGridScroll(isShow, column['colId']);
  }

  showHideColumnOnGridScroll(isShow, fieldName) {
    if (this.gridOptions == null) return;
    this.gridOptions.columnApi.setColumnVisible(fieldName, isShow);
  }

  renderOverlays() {

    var isFilter = this.gridOptions.api.isAnyFilterPresent();
    var isNoData = this.gridOptions.api.getDisplayedRowCount() == 0;
    if (this.isOwnerNotFound == true) {
      if (!isNoData)
        this.deleteFilterOverlay();

      this.insertBadOwnerOverlay();
      this.isShowGridNoDataOverlay = false;
    }
    else {
      this.deleteFilterOverlay();

      if ((isFilter && !isNoData) || (!isFilter && !isNoData)) {
        this.isShowGridNoDataOverlay = false;
      }

      if (!isFilter && isNoData) {
        this.isShowGridNoDataOverlay = true;
      }

      if (isFilter && isNoData) {
        this.insertNoDataFilterOverlay();
        this.isShowGridNoDataOverlay = false;
      }
    }
  }
  /**
   * When ag-grid filter has been changed
   * 1: insert or remove OverLayForNoDataFilter
   * 2: reset inputs of filter
   */
  onGridFilterChanged() {

    this.renderOverlays();

    this.resetFloatingFilterInputCls();
    this.renderGridCheckboxImage();
    this.renderScrollArrow();
    this.removeAgMenu();
  }

  /**
   * Append no-data filter overlay to DOM
   */
  insertNoDataFilterOverlay() {
    var filterOverlay = this.el.nativeElement.querySelector(this.CLS_FILTER_OVERLAY);
    if (filterOverlay == null)
      this.el.nativeElement.querySelector('.ag-bl-center .ag-bl-overlay').insertAdjacentHTML('afterend', this.TEMPLATE_GRID_NODATA_FILTER);
  }

  /**
   * Remove no-data filter overlay
   */
  deleteFilterOverlay() {
    var filterOverlay = this.el.nativeElement.querySelector(this.CLS_FILTER_OVERLAY);
    var badOwnerOverlay = this.el.nativeElement.querySelector(this.CLS_FILTER_OVERLAY_BAD_OWNER);
    if (filterOverlay != null)
      filterOverlay.parentElement.removeChild(filterOverlay);
    if (badOwnerOverlay != null) badOwnerOverlay.parentElement.removeChild(badOwnerOverlay);
  }

  insertBadOwnerOverlay() {
    var overlay = this.el.nativeElement.querySelector(this.CLS_FILTER_OVERLAY_BAD_OWNER);
    if (overlay != null) return;
    this.el.nativeElement.querySelector('.ag-bl-center .ag-bl-overlay').insertAdjacentHTML('afterend', this.TEMPLATE_GRID_BAD_OWNER);
  }

  insertLoadingOverlay() {
    var overlay = this.el.nativeElement.querySelector(this.CLS_FILTER_OVERLAY_LOADING);
    if (overlay != null) {
      this.el.nativeElement.querySelector('.ag-bl-center .ag-bl-overlay').style.display = 'block'
      return;
    }
    const loading = document.createElement('div')
    loading.style.height = '100%' 
    let dom = this.el.nativeElement.querySelector('.ag-bl-center .ag-bl-overlay .ag-overlay-wrapper')
    if (dom) {
      this.el.nativeElement.querySelector('.ag-bl-center .ag-bl-overlay').style.display = 'block'
      loading.innerHTML = this.TEMPLATE_GRID_LOADING
      dom.appendChild(loading);
    } else {
      loading.className = 'ag-overlay-panel'
      loading.innerHTML = `<div class="ag-overlay-wrapper"><div style="height: 100%;">${this.TEMPLATE_GRID_LOADING}</div></div>`
      dom = this.el.nativeElement.querySelector('.ag-bl-center .ag-bl-overlay')
      dom.style.display = 'block'
      dom.appendChild(loading);
    }
  }
  

  renderGridCheckboxImage() {
    if (!this.GRID_SELECTION_CHECKBOX_STYLES.hasOwnProperty(this.gridSelectionCheckboxStyle)) return;

    //header
    this.el.nativeElement.querySelector('.ag-header .ag-checkbox-unchecked img').style.display = 'none';
    this.el.nativeElement.querySelector('.ag-header .ag-checkbox-checked img').style.display = 'none';
    this.el.nativeElement.querySelector('.ag-header .ag-checkbox-indeterminate img').style.display = 'none';

    //body
    var rowCheckeds = this.el.nativeElement.querySelectorAll('.ag-row .ag-selection-checkbox img:nth-child(1)');
    rowCheckeds.forEach(element => {
      element.src = this.GRID_SELECTION_CHECKBOX_STYLES[this.gridSelectionCheckboxStyle]['checked'];
    });
    var rowBodys = this.el.nativeElement.querySelectorAll('.ag-row .ag-selection-checkbox img:nth-child(2)');
    rowBodys.forEach(element => {
      element.src = this.GRID_SELECTION_CHECKBOX_STYLES[this.gridSelectionCheckboxStyle]['normal'];
    });
  }

  /**
   * Reset filters input-text class
   */
  resetFloatingFilterInputCls() {
    var inputs = this.el.nativeElement.querySelectorAll('.ag-floating-filter-input');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value.length == 0) inputs[i].classList.remove('active');
      else inputs[i].classList.add('active');
    }
  }

  fixedAgMenu() {
    setTimeout(() => {
      this.fixedAgMenuDelay();
    }, 100);
  }
  fixedAgMenuDelay() {
    var agMenu = this.el.nativeElement.querySelector('.ag-menu');
    var agFilterSelect = agMenu.querySelector('.ag-filter-select');
    if (agFilterSelect == null) return;

    var selectSize = agFilterSelect.getAttribute('size');
    if (parseInt(selectSize) != 6) agFilterSelect.setAttribute('size', '6');
  }

  removeAgMenu() {
    var agMenu = this.el.nativeElement.querySelector('.ag-menu');
    if (agMenu == null) return;

    agMenu.style.display = 'none';
  }

  /**Start selected animate */
  prepareSelectedAnimate() {
    this.isPrepareSelectedAnimation = true;
    this.selectedNodeIndexsForAnimation = [];

    let selectedNodes = this.gridOptions.api.getSelectedNodes();
    selectedNodes.forEach(element => {
      this.selectedNodeIndexsForAnimation.push(element.rowIndex);
    });
  }
  prepareSelectedAnimateByNodes(nodes) {
    this.isPrepareSelectedAnimation = true;
    this.selectedNodeIndexsForAnimation = [];

    nodes.forEach(element => {
      this.selectedNodeIndexsForAnimation.push(element.rowIndex);
    });
  }

  selectedAnimateDelay(delay?: number) {
    setTimeout(
      () => {
        this.selectedAnimate();
      },
      delay == null ? 100 : delay
    );
  }

  selectedAnimate() {
    if (!this.isPrepareSelectedAnimation || this.el == null || this.selectedNodeIndexsForAnimation.length == 0) return;

    var leftRows = this.el.nativeElement.querySelectorAll('.ag-pinned-left-cols-container .ag-row');
    this._selectedAnimate(leftRows);

    var containerRows = this.el.nativeElement.querySelectorAll('.ag-body-container .ag-row');
    this._selectedAnimate(containerRows);

    this.isPrepareSelectedAnimation = false;
    this.selectedNodeIndexsForAnimation = [];
  }

  _selectedAnimate(arr) {
    var i = 0;
    arr.forEach(element => {
      var node = this.gridOptions.api.getDisplayedRowAtIndex(i);
      if (node.isSelected()) {
        node.setSelected(false);
      }

      if (this.selectedNodeIndexsForAnimation.indexOf(i) != -1) {
        element.classList.add('row-update');

        setTimeout(() => {
          element.classList.add('row-default');
          element.classList.remove('row-update');
        }, 2000);
      }
      i++;
    });
  }

  showPaginiation() {
    this.togglePaginiation(true);
  }

  hidePaginiation() {
    this.togglePaginiation(false);
  }

  togglePaginiation(isShow) {
    var south = this.el.nativeElement.querySelector('[ref="south"]');
    if (south) {
      south.style.display = isShow ? 'block' : 'none';
      this.isShowPaginiation = isShow;
    }
  }

  autoTogglePagination() {
    var isShow = this.gridOptions.api.getDisplayedRowCount() > 0;
    this.togglePaginiation(isShow);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/util/AgGridHelper.ts